




































import { Vue, Component, Emit, Prop } from 'nuxt-property-decorator';
import TooltipButton from '@/components/ui/TooltipButton.vue';

@Component({
  components: {
    TooltipButton
  }
})
export default class NoteItemTools extends Vue {
  @Prop({ type: Boolean, default: false })
  canNavigateToHighlight!: boolean;

  @Emit('edit-note')
  editNote(): boolean {
    return true;
  }

  @Emit('delete-note')
  deleteNote(): boolean {
    return true;
  }

  @Emit('navigate-to-highlight')
  navigateToHighlight(): boolean {
    return true;
  }
}
